var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.text))]),_vm._t("default",function(){return [_c('td',{staticClass:"value-column",domProps:{"innerHTML":_vm._s(_vm.correctValue(_vm.value) + '' + _vm.additionalPropertyText)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }